import useAppMutation from 'hooks/useAppMutation';
import API from 'services/API';

export const DELETE_INTERNAL_CUSTOM_DATA_FIELDS_MUTATION_KEY =
  'delete-internal-custom-data-fields';

const useDeleteInternalCustomDataField = () => {
  const {
    mutateAsync: deleteInternalCustomField,
    isLoading: isDeletingInternalCustomField,
  } = useAppMutation(
    [DELETE_INTERNAL_CUSTOM_DATA_FIELDS_MUTATION_KEY],
    (uid: string) => {
      return API.delete(`/api/internal/custom-data-fields/${uid}`);
    },
  );

  return {
    deleteInternalCustomField,
    isDeletingInternalCustomField,
  };
};

export default useDeleteInternalCustomDataField;
